import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createI18n } from 'vue-i18n';

import nl from './locales/nl.json';
import fr from './locales/fr.json';
import en from './locales/en.json';
import de from './locales/de.json';

const i18n = createI18n({
  locale: 'nl',
  fallbackLocale: 'nl',
  messages: { nl, fr, en, de }
});

const GA_MEASUREMENT_ID = 'G-BT9G53JTV4'; // VERVANG DIT MET JE EIGEN GOOGLE ANALYTICS MEASUREMENT ID
window[`ga-disable-${GA_MEASUREMENT_ID}`] = true; // Standaard uit tot expliciete toestemming

// Google Analytics initialisatie (globale wachtrij)
window.dataLayer = window.dataLayer || [];
window.gtag = function gtag() { window.dataLayer.push(arguments); };

// Stel standaard consent in op 'denied' voordat er iets geladen wordt
window.gtag('consent', 'default', {
  'analytics_storage': 'denied',
  'ad_storage': 'denied'
});

function loadGoogleAnalytics() {
  if (window.gaLoaded) return; // Voorkom meerdere keren laden

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  script.onload = () => {
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);
    window.gaLoaded = true;
    console.log('Google Analytics script geladen en geïnitialiseerd.');
  };
}

function checkAndLoadAnalytics() {
  const consentString = localStorage.getItem('cookie-consent');
  if (consentString) {
    try {
      const preferences = JSON.parse(consentString);
      
      // Update consent status direct op basis van opgeslagen voorkeuren
      window.gtag('consent', 'update', {
        'analytics_storage': preferences.analytics ? 'granted' : 'denied',
        'ad_storage': preferences.marketing ? 'granted' : 'denied'
      });

      if (preferences.analytics) {
        // Zorg ervoor dat de disable-vlag weg is als we toestemming hebben
        delete window[`ga-disable-${GA_MEASUREMENT_ID}`];
        loadGoogleAnalytics();
      } else {
        // Als analytics expliciet is geweigerd, zorg ervoor dat GA is uitgeschakeld
        window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
        console.log('Google Analytics expliciet uitgeschakeld.');
      }
    } catch (e) {
      console.error('Fout bij het parsen van cookie-toestemming uit localStorage:', e);
    }
  }
}

// Controleer toestemming bij de initiële laadbeurt
checkAndLoadAnalytics();

// Luister naar wijzigingen in cookie-toestemming van de CookieBanner
window.addEventListener('cookie-consent-changed', (event) => {
  const preferences = event.detail;
  
  // Stuur een expliciete consent update. Dit is de sleutel om cookies 
  // direct te activeren/deactiveren zonder refresh.
  window.gtag('consent', 'update', {
    'analytics_storage': preferences.analytics ? 'granted' : 'denied',
    'ad_storage': preferences.marketing ? 'granted' : 'denied'
  });

  if (preferences.analytics) {
    // Verwijder de disable-vlag en herinitialiseer GA
    delete window[`ga-disable-${GA_MEASUREMENT_ID}`];
    loadGoogleAnalytics();
    
    // Stuur de config opnieuw om er zeker van te zijn dat de tracker actief is
    window.gtag('config', GA_MEASUREMENT_ID, { 
      'cookie_flags': 'SameSite=Lax;Secure',
      'update': true // Extra hint voor GA om instellingen te verversen
    });
    
    console.log('Google Analytics ingeschakeld en cookies (opnieuw) geactiveerd.');
  } else {
    // Schakel GA uit als toestemming wordt ingetrokken
    window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
    console.log('Google Analytics uitgeschakeld via toestemmingswijziging.');
  }
});

createApp(App).use(router).use(i18n).mount('#app')
